import { createRoot, type Root } from "react-dom/client";
import AboutUs from "../pages/AboutUs/AboutUs";
import "../index.css";
import "../pages/AboutUs/AboutUs.recovered.css";
import "../pages/AboutUs/AboutUs.custom.css";

let root: Root | null = null;

function mount(element: HTMLElement) {
  if (root) return;

  root = createRoot(element);
  root.render(<AboutUs />);
}

function unmount() {
  root?.unmount();
  root = null;
}

window.ACADAboutUs = { mount, unmount };

function boot() {
  const element = document.getElementById("about-us-root");
  if (element) mount(element);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot, { once: true });
} else {
  boot();
}
